// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1922":"f2d82e57","5362":"a7d6ffe7","5837":"f2d82e57","6756":"62675b60","7064":"a7d6ffe7"}[chunkId] + ".chunk.css";
};